export const SET_WORKOUTS = 'SET_WORKOUTS';
export const SET_WORKOUT_BY_ID = 'SET_WORKOUT_BY_ID';
export const RESET_WORKOUT_BY_ID = 'RESET_WORKOUT_BY_ID';
